import { useGlobalState } from "./modules/useGlobalState";
import { useLocationLogic } from "./modules/useLocationLogic";
import { useAuthLogic } from "./modules/useAuthLogic";
import { useQueueLogic } from "./modules/useQueueLogic";
import { useBusinessLogic } from "./modules/useBusinessLogic";
import { useMiscLogic } from "./modules/useMiscLogic";
import { useAppEffects } from "./modules/useAppEffects";

export function useAppLogic(API_URL) {
  // 1. Initialize all state variables and refs
  const state = useGlobalState();

  // 2. Initialize domain-specific logic modules
  const locationLogic = useLocationLogic(API_URL, state);
  const businessLogic = useBusinessLogic(API_URL, state);
  const queueLogic = useQueueLogic(API_URL, state);
  const miscLogic = useMiscLogic(API_URL, state);

  // Auth requires access to fetchNearbyBusinesses and requestLocation
  const authLogic = useAuthLogic(API_URL, state, {
    fetchNearbyBusinesses: businessLogic.fetchNearbyBusinesses,
    requestLocation: locationLogic.requestLocation,
    fetchBusinessTypes: businessLogic.fetchBusinessTypes,
  });

  // 3. Initialize global side effects (sockets, platform detect, initial fetch)
  useAppEffects(API_URL, state, {
    fetchBusinessTypes: businessLogic.fetchBusinessTypes,
    fetchQueueInfo: queueLogic.fetchQueueInfo,
    requestLocation: locationLogic.requestLocation,
  });

  // 4. Return everything combined so App.jsx requires zero changes
  return {
    ...state,
    ...locationLogic,
    ...authLogic,
    ...queueLogic,
    ...businessLogic,
    ...miscLogic,
  };
}
